// extracted by mini-css-extract-plugin
export default {"readyPaymentUnpaid":"Cells_readyPaymentUnpaid__cCZiV","paymentStatusFailed":"Cells_paymentStatusFailed__vGeyr"};